import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import MasterServices from "../../services/axioServices/apiServices/MasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ValidationText from "../../utils/validation/ValidationText.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ToggleSwitch from "../../components/common/ToggleSwitch.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class packingMaterial extends Component {
  constructor(props) {
    super(props);
    this.masterServices = new MasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isPharmaSoftware: false,
      _id: "",
      packingMaterialList: [],
      totalCount: 0,
      isEditing: false,
      isGridView: true,
      tableStatus: "",
      isLoading: false,
      packingMaterialDetails: {
        pmName: "",
        specification: "",
        specificationNo: "",
        pmUOM: "",
        pmCategory: "",
        storageCondition: "",
        pmPurchaseRate: null,
        pmPurchaseQty: null,
        pmTestingCharge: null,
        pmSize: "",
        pmMinQty: null,
        pmMaxQty: null,
        pmSampleQty: null,
        weightUnit: null,
        labTestRequire: 0,
      },
      packingMaterialSizeList: [],
      storageConditionList: [],
      pmCategoryList: [],
      rmUOMList: [
        { uom: "GM" },
        { uom: "KGS" },
        { uom: "IU" },
        { uom: "LTR" },
        { uom: "MCG" },
        { uom: "MG" },
        { uom: "ML" },
        { uom: "NOS" },
      ],
      searchByItemName: "",
      validationRules: {
        pmName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "item name"
            ),
          },
        ],
        // pmUOM: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.SelectRequired.replace(
        //       "{0}",
        //       "uom"
        //     ),
        //   },
        // ],
        // pmCategory: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.SelectRequired.replace(
        //       "{0}",
        //       "category"
        //     ),
        //   },
        // ],
        // storageCondition: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.SelectRequired.replace(
        //       "{0}",
        //       "storage condition"
        //     ),
        //   },
        // ],
        // pmPurchaseRate: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "purchase rate"
        //     ),
        //   },
        // ],
        // pmPurchaseQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "purchase qty"
        //     ),
        //   },
        // ],
        // pmTestingCharge: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "testing charge"
        //     ),
        //   },
        // ],
        // pmSize: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.SelectRequired.replace(
        //       "{0}",
        //       "size"
        //     ),
        //   },
        // ],
        // pmMinQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "minimum qty"
        //     ),
        //   },
        // ],
        // pmMaxQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "maximum qty"
        //     ),
        //   },
        // ],
        // pmSampleQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "sample qty"
        //     ),
        //   },
        // ],
        // weightUnit: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "weight/unit"
        //     ),
        //   },
        // ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    if (!this.isCalled) {
      this.getAllPackingMaterials(this.state.searchByItemName);
      this.isCalled = true;
    }

    let cookies = getAuthProps()
    if (cookies) {
      this.setState({ isPharmaSoftware: cookies.isPharmaSoftware })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchByItemName !== this.state.searchByItemName && !this.isCalled) {
      this.getAllPackingMaterials(this.state.searchByItemName);
      this.isCalled = true;
    }
  }

  getAllPackingMaterials = (ItemName) => {
    this.setState({ tableStatus: "Loading..." })
    let request = [ItemName];

    this.masterServices.getAllPackingMaterials(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let totalCount = response.responseData.totalCount;
        if (totalCount === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        const newMaterials = response.responseData.responseData;

        this.setState({ packingMaterialList: newMaterials, totalCount: totalCount }, () => {
          this.getAllPMCategory()
        })

      } else {
        this.setState({ tableStatus: "" })
        this.getAllPMCategory();
        this.SwalServices.Error(response.Message);
      }
    });
  };


  getPackingMaterialById = (id) => {
    this.masterServices.getPackingMaterialById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        details.pmPurchaseRate = Number(details.pmPurchaseRate) ? Number(details.pmPurchaseRate).toFixed(3) : 0;
        details.pmPurchaseQty = Number(details.pmPurchaseQty) ? Number(details.pmPurchaseQty).toFixed(3) : 0;
        details.pmTestingCharge = Number(details.pmTestingCharge) ? Number(details.pmTestingCharge).toFixed(3) : 0;
        details.pmMinQty = Number(details.pmMinQty) ? Number(details.pmMinQty).toFixed(3) : 0;
        details.pmMaxQty = Number(details.pmMaxQty) ? Number(details.pmMaxQty).toFixed(3) : 0;
        details.labTestRequire = details.labTestRequire ? 1 : 0;
        this.setState(
          { packingMaterialDetails: details, _id: details._id },
          () => {
            this.setState({ isEditing: true, isGridView: false });
          }
        );
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPMCategory = () => {
    this.commonServices.getAllPMCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ pmCategoryList: response.responseData }, () => {
          this.getAllPackingMaterialSize();
        });
      } else {
        this.getAllPackingMaterialSize();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialSize = () => {
    this.commonServices.getAllPackingMaterialSize().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState(
          { packingMaterialSizeList: response.responseData },
          () => {
            this.getAllStorageConditions();
          }
        );
      } else {
        this.getAllStorageConditions();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllStorageConditions = () => {
    this.commonServices.getAllStorageConditions().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ storageConditionList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.packingMaterialDetails;
    details[name] = value.toUpperCase();
    this.setState({ userDetails: details });
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;
    let details = this.state.packingMaterialDetails;
    details[name] = selectedYear;
    this.setState({ packingMaterialDetails: details });
  };

  handleCheckbox = (e, name) => {
    let details = this.state.packingMaterialDetails;
    details[name] = !details.NonInventoryItem;
    this.setState({ packingMaterialDetails: details });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.packingMaterialDetails;
    details.pmName = "";
    details.specification = "";
    details.specificationNo = "";
    details.pmUOM = "";
    details.pmCategory = "";
    details.storageCondition = "";
    details.pmPurchaseRate = null;
    details.pmPurchaseQty = null;
    details.pmTestingCharge = null;
    details.pmSize = "";
    details.pmMinQty = "";
    details.pmMaxQty = "";
    details.pmSampleQty = null;
    details.weightUnit = null;
    details.labTestRequire = 0;

    this.setState(
      {
        packingMaterialDetails: details,
        _id: "",
        validState: validState,
        searchByItemName: "",
        tableStatus: "",
        isEditing: false,
      },
      () => {
        this.getAllPackingMaterials(this.state.searchByItemName);
      }
    );
  };

  addEditPackingMaterial = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.packingMaterialDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        request.labTestRequire = request.labTestRequire ? true : false;
        this.masterServices.addEditPackingMaterial(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.resetForm();
            this.setState({ isGridView: true, isLoading: false });
          } else if (response.statusCode === 409) {
            this.SwalServices.Warning(response.Message);
            this.setState({ isGridView: true, isLoading: false });
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      });
    }
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllPackingMaterials(this.state.searchByItemName);
    });
  };

  deletePackingMaterialById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this item?`
    ).then((response) => {
      if (response === true) {
        this.masterServices.deletePackingMaterialById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.setState({ searchByItemName: "" }, () => {
              this.getAllPackingMaterials(this.state.searchByItemName);
            });
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    });
  }


  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.packingMaterialDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  handleToggle = (e) => {
    let checked = e.target.checked;
    this.setState({
      packingMaterialDetails: {
        ...this.state.packingMaterialDetails,
        labTestRequire: checked ? 1 : 0
      }
    });
  }

  render() {
    return (
      <div className="packingMaterial-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-[10px]">
              <div className="item-grp">
                <div className="item-search-box w-[50%]">
                  <label>Item name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autocomplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "30%" }}>Item Name</td>
                      <td style={{ width: "10%" }}>U.O.M</td>
                      <td style={{ width: "10%" }}>Category</td>
                      <td style={{ width: "10%" }}>Testing Charge</td>
                      <td style={{ width: "10%" }}>Minimum Qty.</td>
                      <td style={{ width: "10%" }}>Maximum Qty.</td>
                      <td style={{ width: "10%" }}>Weight/Unit</td>
                      <td style={{ width: "10%", textAlign: "center" }}>
                        Action
                      </td>
                    </tr>
                  </thead>
                  <tbody >
                    {this.state.packingMaterialList &&
                      this.state.packingMaterialList.length > 0 ? (
                      this.state.packingMaterialList.map((item, key) => (

                        <tr key={key}>
                          <td>{item.pmName}</td>
                          <td>{item.pmUOM}</td>
                          <td>{item.pmCategory}</td>
                          <td>
                            {item.pmTestingCharge
                              ? item.pmTestingCharge.toFixed(2)
                              : item.pmTestingCharge}
                          </td>
                          <td>{item.pmMinQty}</td>
                          <td>{item.pmMaxQty}</td>
                          <td>{item.weightUnit}</td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className="search-btn"
                              onClick={() =>
                                this.getPackingMaterialById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.deletePackingMaterialById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>

                      ))
                    ) : this.state.packingMaterialList
                      && this.state.packingMaterialList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={8} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.packingMaterialList
                      && this.state.packingMaterialList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : null}

        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid grid-cols-2 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>Item Name</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmName ? "errorInput" : ""}`}
                      type="text"
                      id="pmName"
                      name="pmName"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmName}
                      onChange={(event) => this.handleChange(event, "pmName")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmName}
                    /> */}
                  </div>
                  <div className="inputInner-grp grid grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Specification</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="specification"
                        name="specification"
                        autocomplete="off"
                        value={this.state.packingMaterialDetails.specification}
                        onChange={(event) =>
                          this.handleChange(event, "specification")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>Specification No</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="specificationNo"
                        name="specificationNo"
                        autocomplete="off"
                        value={this.state.packingMaterialDetails.specificationNo}
                        onChange={(event) =>
                          this.handleChange(event, "specificationNo")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>U-O-M</label>
                    <select
                      className={`inputFocus ${this.state.validState?.error?.pmUOM ? "errorInput" : ""}`}
                      name="pmUOM"
                      value={this.state.packingMaterialDetails.pmUOM}
                      onChange={(e) => this.handleDropdownChange(e, "pmUOM")}
                    >
                      <option>Select</option>
                      {this.state.rmUOMList.map((x, key) => (
                        <option key={key} value={x.uom}>
                          {x.uom}
                        </option>
                      ))}
                    </select>
                    {/* <ValidationText error={this.state.validState.error.pmUOM} /> */}
                  </div>
                  <div className="input-grp">
                    <label>Category</label>
                    <select
                      className={`inputFocus ${this.state.validState?.error?.pmCategory ? "errorInput" : ""}`}
                      name="pmCategory"
                      value={this.state.packingMaterialDetails.pmCategory}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "pmCategory")
                      }
                    >
                      <option>Select</option>
                      {this.state.pmCategoryList.map((x, key) => (
                        <option key={key} value={x.pmCategory}>
                          {x.pmCategory}
                        </option>
                      ))}
                    </select>
                    {/* <ValidationText
                      error={this.state.validState.error.pmCategory}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Storage Condition</label>
                    <select
                      className={`inputFocus ${this.state.validState?.error?.storageCondition ? "errorInput" : ""}`}
                      name="storageCondition"
                      value={this.state.packingMaterialDetails.storageCondition}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "storageCondition")
                      }
                    >
                      <option>Select</option>
                      {this.state.storageConditionList &&
                        this.state.storageConditionList.length > 0 &&
                        this.state.storageConditionList.map((code, key) => (
                          <option key={key} value={code.storageCondition}>
                            {code.storageCondition}
                          </option>
                        ))}
                    </select>
                    {/* <ValidationText
                      error={this.state.validState.error.storageCondition}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Size</label>
                    <select
                      className={`inputFocus ${this.state.validState?.error?.pmSize ? "errorInput" : ""}`}
                      name="pmSize"
                      value={this.state.packingMaterialDetails.pmSize}
                      onChange={(e) => this.handleDropdownChange(e, "pmSize")}
                    >
                      <option>Select</option>
                      {this.state.packingMaterialSizeList.map((x, key) => (
                        <option key={key} value={x.packingMaterialSize}>
                          {x.packingMaterialSize}
                        </option>
                      ))}
                    </select>
                    {/* <ValidationText
                      error={this.state.validState.error.pmSize}
                    /> */}
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3">
                  <div className="input-grp">
                    <label>Std. Purch. Rate</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmPurchaseRate ? "errorInput" : ""}`}
                      type="number"
                      id="pmPurchaseRate"
                      name="pmPurchaseRate"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmPurchaseRate}
                      onChange={(event) =>
                        this.handleChange(event, "pmPurchaseRate")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmPurchaseRate}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Std. Purch. Qty.</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmPurchaseQty ? "errorInput" : ""}`}
                      type="number"
                      id="pmPurchaseQty"
                      name="pmPurchaseQty"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmPurchaseQty}
                      onChange={(event) =>
                        this.handleChange(event, "pmPurchaseQty")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmPurchaseQty}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Testing Charge</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmTestingCharge ? "errorInput" : ""}`}
                      type="number"
                      id="pmTestingCharge"
                      name="pmTestingCharge"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmTestingCharge}
                      onChange={(event) =>
                        this.handleChange(event, "pmTestingCharge")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmTestingCharge}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Sample Qty.</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmSampleQty ? "errorInput" : ""}`}
                      type="number"
                      id="pmSampleQty"
                      name="pmSampleQty"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmSampleQty}
                      onChange={(event) =>
                        this.handleChange(event, "pmSampleQty")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmSampleQty}
                    /> */}
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3.5">
                  <div className="input-grp">
                    <label>Minimum Qty.</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmMinQty ? "errorInput" : ""}`}
                      type="number"
                      id="pmMinQty"
                      name="pmMinQty"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmMinQty}
                      onChange={(event) => this.handleChange(event, "pmMinQty")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmMinQty}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Maximum Qty.</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.pmMaxQty ? "errorInput" : ""}`}
                      type="number"
                      id="pmMaxQty"
                      name="pmMaxQty"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.pmMaxQty}
                      onChange={(event) => this.handleChange(event, "pmMaxQty")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pmMaxQty}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Weight/Unit</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.weightUnit ? "errorInput" : ""}`}
                      type="number"
                      id="weightUnit"
                      name="weightUnit"
                      autocomplete="off"
                      value={this.state.packingMaterialDetails.weightUnit}
                      onChange={(event) =>
                        this.handleChange(event, "weightUnit")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.weightUnit}
                    /> */}
                  </div>
                  {this.state.isPharmaSoftware === true ?
                    <div className="input-grp flex items-center gap-2">
                      <label className="!mb-0 whitespace-nowrap">Lab test require</label>
                      <ToggleSwitch
                        checked={this.state.packingMaterialDetails.labTestRequire === 1}
                        onChange={this.handleToggle}
                      />
                    </div>
                    : null}
                  <div className="itemInner-grp grid grid-cols-2 !gap-2.5">

                  </div>
                </div>
              </div>
              <div className="btn-grp">
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPackingMaterial()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPackingMaterial()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  disabled={this.state.isLoading}
                  className="cancel-btn"
                  onClick={() => this.openGridView()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default packingMaterial;
